export const objectToUrl = (data: any) => {
  const jsonString = JSON.stringify(data);
  return encodeURIComponent(jsonString);
};

export const urlToObject = (url: any) => {
  const decodedString = decodeURIComponent(url);
  return JSON.parse(decodedString);
};
